/**
 * Trims the Developers address back to what is ours before signing in.
 *
 * The reference viewer appends its own route after ours as the reader moves through it:
 * `#/developers?tab=reference/tag/document/POST/api/v2/...`. While the page is open that is
 * harmless. The trouble comes on RELOAD, or when that link is shared: sign-in sends the whole
 * address as `redirect_uri`, and the identity server rejects one that carries braces (those of
 * any operation with a path parameter) with an "invalid redirect_uri" page nobody can leave.
 *
 * So, before signing in, `tab` keeps only what comes before the first slash. The exact spot of
 * the reference is lost; the tab, which is what the link promises, is kept.
 *
 * Must be called BEFORE `sso.init`.
 */
export const cleanDevelopersAddress = (): void => {
  const hash = window.location.hash;
  if (!hash.replace(/^#\/?/, '').startsWith('developers')) return;
  const [route, ...rest] = hash.split('?');
  const params = new URLSearchParams(rest.join('?'));
  const tab = params.get('tab');
  if (!tab || !tab.includes('/')) return;
  params.set('tab', tab.split('/')[0]);
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${route}?${params.toString()}`);
};
